import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const sendblue = defineConnector({
  identifier: "sendblue",
  name: "Sendblue",
  tagLine: "iMessage, SMS, and RCS messaging",
  keywords: "send blue mms texting phone numbers contacts group messages",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.sendblue\\.co/.*",
  auth: (app) =>
    headerAuth([
      { name: "SB-API-KEY-ID", value: app.secret.apiKey },
      { name: "SB-API-SECRET-KEY", value: app.secret.apiSecret },
    ]),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Open your [Sendblue dashboard](https://dashboard.sendblue.com/) and copy your **API key** and **API secret**. See the [credentials guide](https://docs.sendblue.com/getting-started/credentials/) for details.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "input",
          label: "API secret",
          required: true,
          target: { kind: "secrets", field: "apiSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.sendblue.co/api/v2/contacts/count",
  },
});
